// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"fe70a506","118":"a89294d8","250":"b85b6925","787":"73f047a7","842":"6c5e1db1","920":"2303bb80"}[chunkId] + ".chunk.js";
};